import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

@Pipe({
  name: 'localizedUppercase',
  pure: true
})
export class LocalizedUppercasePipe implements PipeTransform {
  translocoService = inject(TranslocoService);
  transform(value: string): string {
    const activeLang = this.translocoService.getActiveLang();
    const locale = this.mapLangToLocale(activeLang);
    return value?.toLocaleUpperCase(locale);
  }
  private mapLangToLocale(lang: string): string {

    const langLocaleMap: { [key: string]: string } = {
      en: 'en-US',
      tr: 'tr-TR',
      de: 'de-DE',
    };

    return langLocaleMap[lang] || 'en-US';
  }
}
